import {API} from '@utils'

// ** Update & Get Updated Bookmarks Array
export const saveQuery = (data, callback) => {
  API.post(`/saved-query`, data).then((data) => {
    callback(data)
  })
}
export const deleteQuery = (id, callback, callbackError) => {
  API.delete(`/saved-query/${id}`, { silent: true }).then((data) => {
    callback(data)
  })
  .catch(callbackError)
}
